import { createContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

import {
  getData,
  postData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "./api";

import { Per_Page_Dropdown } from "./common";
import { TOKEN_COOKIE, clearSession, decodeToken } from "./auth";
export const Context = createContext();

const AppContext = ({ children }) => {
  // const IMG_URL = "http://127.0.0.1:1710";
  // const IMG_URL = "http://192.168.16.53:1710";
  // const IMG_URL = "http://192.168.1.86:1710";

  //
  // const IMG_URL = "https://bluechartnode.profcymadev.com:1710";

  const IMG_URL = "https://node.bluechartapp.in";

  const navigate = useNavigate();

  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);

  const [userdata, setUserData] = useState({});
  const [isAllow, setisAllow] = useState([]);

  const minLength = 2; // Set your desired minimum length
  const maxLength = 30; // Set your desired maximum length

  const signinRef = useRef(false);
  const expiryTimer = useRef(null);

  useEffect(() => {
    signinRef.current = signin;
    isTokenValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signin]);

  // Sign out locally (token removed, state cleared, back to login).
  const endSession = (reason) => {
    clearTimeout(expiryTimer.current);
    clearSession({ expired: reason === "expired" });
    setSignin(false);
    setisAllow([]);
    navigate("/");
  };

  // Light check used by the expiry timer and when the tab regains focus (a
  // sleeping laptop or another tab may have let the token expire / be removed).
  const checkSession = () => {
    if (!signinRef.current) return;
    const stored = Cookies.get(TOKEN_COOKIE);
    if (!stored) return endSession("missing");
    const decoded = decodeToken(stored);
    if (!decoded) return endSession("invalid");
    if (decoded.exp < Date.now() / 1000) endSession("expired");
  };

  const scheduleExpiry = (exp) => {
    clearTimeout(expiryTimer.current);
    if (typeof exp !== "number") return;
    const ms = Math.min((exp - Date.now() / 1000) * 1000 + 1000, 2147483647);
    expiryTimer.current = setTimeout(checkSession, Math.max(ms, 0));
  };

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") checkSession();
    };
    window.addEventListener("focus", checkSession);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", checkSession);
      document.removeEventListener("visibilitychange", onVisible);
      clearTimeout(expiryTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getuserData = async (id) => {
    const response = await getData(`/auth/login/${id}`, { id: id });
    // keep the token's permissions if the refresh fails
    if (response?.data) {
      await setUserData(response.data);
      if (response.data.permissions)
        await setisAllow(response.data.permissions);
    }
  };

  const isTokenValid = async () => {
    const token = Cookies.get(TOKEN_COOKIE);

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = decodeToken(token);
      const currentTime = Date.now() / 1000;

      if (!decodedToken) {
        endSession("invalid");
      } else if (decodedToken.exp < currentTime) {
        endSession("expired");
      } else {
        setisAllow(decodedToken?.permissions);
        getuserData(decodedToken.user);
        setSignin(true);
        scheduleExpiry(decodedToken.exp);
      }
    } else {
      setisAllow([]);
      setSignin(false);
      navigate("/");
    }
  };
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  return (
    <Context.Provider
      value={{
        getData,
        postData,
        // getEditData,
        // editData,
        editStatusData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,

        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        setisAllow,
        isAllow,
        Per_Page_Dropdown,
        toggleSidebar,
        IMG_URL,
        shimmerLoader,
        setShimmerLoader,
        // token,
        // setToken,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
